import { Navigate } from "react-router-dom";
import { usePermissions } from "@/hooks/usePermissions";

/** Default Studio landing: org admins → org Studio; all other Studio users → bundles. */
export function StudioIndexRedirect() {
  const { isOrgadmin } = usePermissions();
  if (isOrgadmin) return <Navigate to="/org/studio" replace />;
  return <Navigate to="/studio/bundles" replace />;
}
